import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { Usuario } from "../entidades/usuario";
import { environment } from "src/environments/environment";
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: "root"
})
export class FuncionariosService {
  constructor(private http: HttpClient) {}

  opcionesHttp = {
    headers: new HttpHeaders({
      "Content-Type": "application/json"
    })
  };

  ConsultarTodosLosFuncionarios() {
    let Data = {
      Operacion: "ConsultarTodosLosFuncionarios"
    };
    return this.http.post(`${environment.apiUrl}/Funcionarios`, Data);
  }

  ConsultarEnviados() {
    return this.http.get(`${environment.apiUrl}/Funcionarios/notificados/si`);
  }

  //  obtenerFuncionario(idFuncionario): Observable<any> {
  //    return this.http.get<Usuario>(environment.apiUrl + `/Funcionarios/${idFuncionario}`, this.opcionesHttp).pipe(
  //      retry(1),
  //      catchError(this.manejarError)
  //    );
  //  }

  obtenerFuncionario(idFuncionario) {
    let Data = {
      Operacion :"datosfuncionario",
      idFuncionario : idFuncionario
    };
    return this.http.post(`${environment.apiUrl}/Funcionarios`, Data);
  }

  

  noNotificados(): Observable<any> {
    return this.http.get<Usuario>(environment.apiUrl + `/Funcionarios/notificados/no`, this.opcionesHttp).pipe(
      retry(1),
      catchError(this.manejarError)
    );
  }

  enviarNotificacion(listaEmails): Observable<any> {
    return this.http
      .post<Usuario>(environment.apiUrl + "/Funcionarios/enviar/notificacion", JSON.stringify(listaEmails), this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  manejarError(error) {
    let mensajeError = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      mensajeError = error.error.message;
    } else {
      // Get server-side error
      mensajeError = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(mensajeError);
    return throwError(mensajeError);
  }


  obtenerPerfil(idFuncionario) {
    let Data = {
      Operacion :"perfil",
      idFuncionario : idFuncionario
    };
    return this.http.post(`${environment.apiUrl}/Funcionarios`, Data);
  }
}
